import { useState } from "react";
import { Breadcrumb, BreadcrumbItem } from "reactstrap";
import useCloud from "../../../../api/api-hooks/cloud/useCloud";
import BasicTableView from "../../CloudListView/BasicTableView";
import useCreateModule from "../../../../api/api-hooks/modules/useCreateModule";
import EditModuleModal from "../../../../components/Modals/EditModuleModal";
import TenantAPI from "../../../../api/api/TenantAPI";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Schema } from "../../../../types/TenantInterfaces";
import { useQuery } from "@tanstack/react-query";

const CloudTenantSchema = ({ urlStart }: { urlStart?: string }) => {
  const { cloudID }: any = useParams();
  const navigate = useNavigate();
  const { cloudLoading } = useCloud(cloudID);
  const { createModule, loading, error } = useCreateModule();
  const [createModal, setCreateModal] = useState(false);
  urlStart = urlStart || "/supportal";

  const { data: schema, isLoading } = useQuery<Schema>({
    queryKey: ["schema", cloudID],
    queryFn: () => TenantAPI.getLatestSchema(cloudID),
    enabled: !!cloudID,
  });

  return (
    <>
      <BasicTableView
        collapsible
        loading={cloudLoading || isLoading}
        items={schema?.CRM?.Modules?.filter((m) => !m?.Protected) ?? []}
        emptyMessage={"No Modules Found"}
        title="Custom Modules"
        getItemTitle={(m) => m.Name}
        titleCSS="tw:rounded-t-md"
        getItemSubtitle={(m) => m.APIName}
        onClick={(m) => navigate(`${urlStart}/${cloudID}/modules/${m.APIName}`)}
      />
      <BasicTableView
        collapsible
        titleCSS="tw:rounded-t-md tw:mt-3"
        loading={cloudLoading || isLoading}
        items={schema?.CRM?.Modules?.filter((m) => !!m?.Protected) ?? []}
        emptyMessage={"No Modules Found"}
        title="Default Modules"
        getItemTitle={(m) => m.Name}
        getItemSubtitle={(m) => m.APIName}
        onClick={(m) => navigate(`${urlStart}/${cloudID}/modules/${m.APIName}`)}
      />

      <EditModuleModal
        open={createModal}
        toggle={() => setCreateModal(false)}
        submitting={loading}
        error={error}
        onUpdate={CreateModule}
        onClose={() => setCreateModal(false)}
        mode={"create"}
        existingName={null}
        tenantID={cloudID}
      />
    </>
  );

  function CreateModule(values: any) {
    createModule({
      moduleName: values?.Name,
      moduleAPIName: values?.APIName,
      onSuccess: onSuccess,
      fields: undefined,
    });
  }

  function onSuccess() {
    setCreateModal(false);
  }
};

interface BreadcrumbSupportal {
  loading: boolean;
  title: string;
  redirectTitle: string;
  redirectPath: string;
}

export const BreadCrumSupportal = ({
  loading,
  title,
  redirectTitle,
  redirectPath,
}: BreadcrumbSupportal) => {
  return (
    <>
      <Breadcrumb className="d-block mt-1" listClassName="breadcrumb-links">
        <BreadcrumbItem>
          <Link to="/supportal">
            <i className="mdi mdi-lifebuoy" />
          </Link>
        </BreadcrumbItem>
        <BreadcrumbItem>
          <Link to={redirectPath}>{redirectTitle}</Link>
        </BreadcrumbItem>
        <BreadcrumbItem>{loading ? "Loading..." : title}</BreadcrumbItem>
      </Breadcrumb>
    </>
  );
};

export default CloudTenantSchema;
